import { startB2bCopilotPlanDemoStreamLoop } from './b2bCopilotPlanDemoStreamLoop.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession.js').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} B2bStreamCtx
 */

/** @param {B2bStreamCtx} ctx */
export function runB2bCopilotPlanDemoStream(ctx) {
  startB2bCopilotPlanDemoStreamLoop(ctx)
}
